const LEGACY_TOKEN_KEY = 'jwt';
const AUTH_AREA_KEY = 'authArea';

const TOKEN_KEYS = {
    generale: 'jwt_generale',
    lavoratore: 'jwt_lavoratore',
    medico: 'jwt_medico',
};

export const getAuthAreaFromSession = () => {
    return sessionStorage.getItem(AUTH_AREA_KEY) || 'generale';
};

export const getTokenStorageKey = (authArea) => {
    return (
        TOKEN_KEYS[authArea || getAuthAreaFromSession()] || TOKEN_KEYS.generale
    );
};

export const getTokenFromLocalStorage = (authArea) => {
    const areaKey = getTokenStorageKey(authArea);
    const areaToken = localStorage.getItem(areaKey);
    if (areaToken) {
        return areaToken;
    }
    // Fallback al token legacy solo per l'area generale, per evitare che
    // un vecchio jwt di un'altra area venga inviato come se fosse di questa.
    return areaKey === TOKEN_KEYS.generale
        ? localStorage.getItem(LEGACY_TOKEN_KEY)
        : null;
};

export const setTokenInLocalStorage = (token, authArea) => {
    if (!token) {
        return;
    }

    const resolvedArea = authArea || getAuthAreaFromSession();
    localStorage.setItem(getTokenStorageKey(resolvedArea), token);

    if (resolvedArea === 'generale') {
        localStorage.setItem(LEGACY_TOKEN_KEY, token);
    }
};

export const removeTokenFromLocalStorage = (authArea) => {
    const resolvedArea = authArea || getAuthAreaFromSession();
    localStorage.removeItem(getTokenStorageKey(resolvedArea));

    if (resolvedArea === 'generale') {
        localStorage.removeItem(LEGACY_TOKEN_KEY);
    }
};

export const removeAllAreaTokens = () => {
    Object.values(TOKEN_KEYS).forEach((key) => localStorage.removeItem(key));
    localStorage.removeItem(LEGACY_TOKEN_KEY);
};
